<template lang="html">
	<div id="app" class="main column">
		<my-header @notif-open="notifPanelActive = true"></my-header>
		<div class="page column">
			<router-view></router-view>
		</div>
		<notification-panel :active="notifPanelActive" @notif-close="notifPanelActive = false"></notification-panel>
	</div>
</template>

<script>
	import myHeader from '@/components/header.vue'
	import NotificationPanel from '@/components/notification-panel'

	export default {
		name: 'Hello',
		components: {
			myHeader,
			NotificationPanel
		},
		data () {
			return {
				notifPanelActive: false
			}
		}
	}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Main.vue?d1ba0faa